export default __webpack_public_path__ + "static/media/dogIcon.72fea167.svg";